<template>
  <div class="hot-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="getHotModule()"
        >刷新</el-button
      >
      <el-dropdown>
        <el-button type="primary" size="mini">
          新增一级模块<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div @click="addFirstModule(0)">视频</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(1)">帖子</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(2)">暗网</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(3)">图集</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(4)">短视频</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(5)">黄游</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(6)">小说</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(7)">漫画</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(8)">动漫</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="addFirstModule(9)">短剧</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      :tree-props="{ children: 'subModules' }"
      row-key="id"
      highlight-current-row
    >
      <el-table-column prop="id" label="模块ID" align="left" width="240"></el-table-column>
      <el-table-column prop="moduleName" label="模块名称" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="模块类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.moduleType == 0">视频</span>
          <span v-if="scope.row.moduleType == 1">帖子</span>
          <span v-if="scope.row.moduleType == 2">暗网</span>
          <span v-if="scope.row.moduleType == 3">图集</span>
          <span v-if="scope.row.moduleType == 4">短视频</span>
          <span v-if="scope.row.moduleType == 5">黄游</span>
          <span v-if="scope.row.moduleType == 6">小说</span>
          <span v-if="scope.row.moduleType == 7">漫画</span>
          <span v-if="scope.row.moduleType == 8">动漫</span>
          <span v-if="scope.row.moduleType == 9">短剧</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="layoutSeries"
        label="模块类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.layoutSeries == 0">海角系</span>
          <span v-if="scope.row.layoutSeries == 1">泡芙系</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="layout"
          label="子模块展示布局"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.layout == 0">宫格</span>
          <span v-if="scope.row.layout == 1">头像</span>
          <span v-if="scope.row.layout == 2">网黄</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="layout"
          label="子模块内容布局"
          align="center"
          width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.vlayout == 0">宫格</span>
          <span v-if="scope.row.vlayout == 1">大横</span>
          <span v-if="scope.row.vlayout == 2">网黄</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="layoutType"
        label="泡芙系布局模式"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.layoutType == 0">四宫格横</span>
          <span v-else-if="scope.row.layoutType == 1">一大四小</span>
          <span v-else-if="scope.row.layoutType == 2">1.5滑动横</span>
          <span v-else-if="scope.row.layoutType == 3">2.5滑动横</span>
          <span v-else-if="scope.row.layoutType == 4">六宫格-横</span>
          <span v-else-if="scope.row.layoutType == 5">列表-横</span>
          <span v-else-if="scope.row.layoutType == 6">大横</span>
          <span v-else-if="scope.row.layoutType == 7">2.5滑动竖</span>
          <span v-else-if="scope.row.layoutType == 8">图集</span>
          <span v-else>四宫格横</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortNum"
        label="排序"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sortNum"
        label="是否启用"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" class="red">关闭</span>
          <span v-if="scope.row.status === 1" class="green">开启</span>
          <span v-if="scope.row.status === 2" class="red">删除</span>
        </template>
      </el-table-column>
      <el-table-column prop="uv" label="UV统计" align="center" width="100">
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="handleAddModule(0, 'add', scope.row)"
            >新增</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="handleAddModule(0, 'edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="handleDelModule(scope.row,scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <add-module ref="addModule" @handlerModule="getHotModule"></add-module>
    <div class="sec-bar"></div>
  </div>
</template>
<script>
import AddModule from "./components/addModule";
import API from "@/api";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      tableData2: [],
      total: 0,
      // 获取列表参数
      param: {
        pageNumber: 1,
        pageSize: 20,
      },
    };
  },
  components: {
    AddModule,
  },
  created() {
    this.getHotModule();
  },
  methods: {
    // 获取热门模块列表
    getHotModule() {
      this.loading = true;
      API.getModuleList(this.param)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = [];
            res.data.map((item) => {
              if (item.list && item.list.length > 0) {
                item.list.forEach((children) => {
                  children.parentName = item.moduleName;
                  children.moduleType = item.moduleType;
                });
                this.tableData.push(...item.list);

                this.tableData.forEach((item) => {
                  item.id = item.moduleID;
                  item.pid = "";
                });
              }
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addFirstModule(moduleType) {
      const currentData = {
        moduleName: "",
        status: 1,
        pid: "",
        id: "",
      };
      this.$refs.addModule.open(moduleType, "add", currentData);
    },
    // 新增热门模块
    handleAddModule(moduleType, type, data) {
      const currentData = {
        ...data,
        status: 1,
        showSummary: true,
      };
      if (type === "add") {
        // 如果pid为0 表示为一级标题
        if (!currentData.pid) {
          currentData.pid = currentData.id;
          currentData.showSummary = false;
        }
        currentData.id = "";
      } else {
        if (!currentData.pid) {
          currentData.showSummary = false;
        }
      }

      this.$refs.addModule.open(moduleType, type, currentData);
    },
    handleDelModule(row,index) {
      this.$confirm("您确定要当前模块吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.deleteModule({ id: row.id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除模块成功",
                type: "success",
              });
              this.tableData.splice(index,1)
              if(this.tableData.length == 0)this.getHotModule();
            } else {
              if (res.tip) {
                this.$message.error(res.tip);
              } else {
                this.$message.error("删除模块失败");
              }
            }
          });
        })
        .catch(() => {});
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getHotModule();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getHotModule(this.param);
    },
  },
};
</script>
